import { ChevronDown } from "lucide-react";

export function FaqDisclosure({
  question,
  answer,
  className = "overflow-hidden rounded-2xl border border-border bg-card px-6 transition-colors hover:border-accent/40 open:border-accent/50 open:shadow-lg",
}: {
  question: string;
  answer: string;
  className?: string;
}) {
  return (
    <details className={`group ${className}`}>
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-left font-display text-lg text-primary [&::-webkit-details-marker]:hidden">
        {question}
        <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180" />
      </summary>
      <p className="pb-5 text-base leading-relaxed text-muted-foreground">{answer}</p>
    </details>
  );
}
